import { Message } from "aderant-conflicts-models";

export const Messages = {
    SearchCannotBeSavedBeforePerform: new Message("Search_Cannot_Be_Saved_Before_Perform", "The search could not be executed. Check the log for more details."),
    SubmitSearchError: new Message("SUBMIT_SEARCH_ERROR", "The search request could not be submitted. Please try again later.")
};
